export const appName = "Fastest";
